import { useState } from 'react';
import {
    Box,
    Button,
    Chip,
    IconButton,
    Paper,
    Stack,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Add, Close, InsertEmoticon } from '@mui/icons-material';
import { AmostrasCor, BotaoCor } from './SeletorCor';
import { SeletorEmoji } from './SeletorEmoji';

const MAX_CHIPS = 6;

export function Aparencia({ value, onChange, corPadrao, rotuloPadrao }) {
    const theme = useTheme();
    const estilo = value ?? {};
    const cor = estilo.cor || corPadrao;
    const chips = estilo.chips ?? [];

    const [novoChip, setNovoChip] = useState('');
    const [corChip, setCorChip] = useState(null);

    const atualizar = (parcial) => onChange({ ...estilo, ...parcial });

    const adicionarChip = () => {
        const texto = novoChip.trim();
        if (!texto || chips.length >= MAX_CHIPS) return;

        atualizar({ chips: [...chips, { label: texto.slice(0, 30), cor: corChip || cor }] });
        setNovoChip('');
    };

    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
                Aparência do card
            </Typography>

            <Stack spacing={2}>
                <Box>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.75 }}>
                        Cor de destaque
                    </Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <AmostrasCor valor={cor} onSelecionar={(valor) => atualizar({ cor: valor })} />
                        {estilo.cor && (
                            <Button size="small" onClick={() => atualizar({ cor: null })}>
                                Padrão do tipo
                            </Button>
                        )}
                    </Stack>
                </Box>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.75 }}>
                            Ícone
                        </Typography>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <SeletorEmoji onSelecionar={(emoji) => atualizar({ emoji })}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={estilo.emoji ? null : <InsertEmoticon />}
                                    sx={{ minWidth: 0 }}
                                >
                                    {estilo.emoji ? <Box component="span" sx={{ fontSize: 18 }}>{estilo.emoji}</Box> : 'Escolher emoji'}
                                </Button>
                            </SeletorEmoji>
                            {estilo.emoji && (
                                <Button size="small" onClick={() => atualizar({ emoji: null })}>
                                    Ícone padrão
                                </Button>
                            )}
                        </Stack>
                    </Box>

                    <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.75 }}>
                            Texto da etiqueta
                        </Typography>
                        <TextField
                            size="small"
                            fullWidth
                            placeholder={rotuloPadrao}
                            value={estilo.rotulo ?? ''}
                            onChange={(evento) => atualizar({ rotulo: evento.target.value.slice(0, 30) || null })}
                        />
                    </Box>
                </Stack>

                <Box>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.75 }}>
                        Chips extras ({chips.length}/{MAX_CHIPS})
                    </Typography>

                    {chips.length > 0 && (
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 1 }}>
                            {chips.map((chip, indice) => (
                                <Chip
                                    key={`${chip.label}-${indice}`}
                                    label={chip.label}
                                    size="small"
                                    onDelete={() => atualizar({ chips: chips.filter((_, i) => i !== indice) })}
                                    sx={{
                                        bgcolor: chip.cor,
                                        color: theme.palette.getContrastText(chip.cor),
                                        fontWeight: 600,
                                        '& .MuiChip-deleteIcon': { color: 'inherit', opacity: 0.7 },
                                    }}
                                />
                            ))}
                        </Stack>
                    )}

                    <Stack direction="row" spacing={1} alignItems="center">
                        <BotaoCor valor={corChip || cor} onSelecionar={setCorChip}>
                            <Tooltip title="Cor do chip">
                                <IconButton size="small">
                                    <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: corChip || cor, outline: '1px solid rgba(0,0,0,0.15)' }} />
                                </IconButton>
                            </Tooltip>
                        </BotaoCor>

                        <TextField
                            size="small"
                            placeholder="Ex.: Novo, Beta, Importante"
                            value={novoChip}
                            disabled={chips.length >= MAX_CHIPS}
                            onChange={(evento) => setNovoChip(evento.target.value)}
                            onKeyDown={(evento) => {
                                if (evento.key === 'Enter') {
                                    evento.preventDefault();
                                    adicionarChip();
                                }
                            }}
                            sx={{ flex: 1 }}
                        />

                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<Add />}
                            onClick={adicionarChip}
                            disabled={!novoChip.trim() || chips.length >= MAX_CHIPS}
                        >
                            Adicionar
                        </Button>
                    </Stack>
                </Box>

                {(estilo.cor || estilo.emoji || estilo.rotulo || chips.length > 0) && (
                    <Box>
                        <Button size="small" color="inherit" startIcon={<Close />} onClick={() => onChange({})}>
                            Restaurar aparência padrão
                        </Button>
                    </Box>
                )}
            </Stack>
        </Paper>
    );
}